import { MimeType } from 'core/enums';

import { IDocumentFile } from './types';

export const getFileTypeOptions = <T extends IDocumentFile>(records: T[]): MimeType[] => {
  return Array.from(new Set(records.map((record) => record.fileMime)));
};

export const createSearchPredicate = <T extends IDocumentFile>(searchTerm?: string) => {
  if (!searchTerm) {
    return () => true;
  }

  return (record: T) => record.fileName.toLowerCase().includes(searchTerm.toLowerCase());
};

export const createFileTypePredicate = <T extends IDocumentFile>(fileTypes?: MimeType[]) => {
  if (!fileTypes?.length) {
    return () => true;
  }

  return (record: T) => fileTypes.includes(record.fileMime);
};

export const combinePredicates = <T extends IDocumentFile>(
  predicates: Array<(record: T) => boolean>
) => {
  return (record: T) => predicates.every((predicate) => predicate(record));
};
